// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OOBSPOaalMGJXJ {\n  padding: 0 12px;\n  word-break: break-word;\n}\n.OOBSPOaalMGJXJ p {\n  margin: 0 0 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmContainer": "OOBSPOaalMGJXJ"
};
export default ___CSS_LOADER_EXPORT___;
